import { Checkbox } from "@/components/ui/checkbox";
import { Label } from "@/components/ui/label";
import { Transaction } from "../../types/TransactionTypes";

interface SelectAllTransactionsProps {
  method: string;
  transactions: Transaction[];
  selectedTransactions: Set<string>;
  onTransactionSelect: (transactionId: string, checked: boolean) => void;
}

export const SelectAllTransactions = ({
  method,
  transactions,
  selectedTransactions,
  onTransactionSelect,
}: SelectAllTransactionsProps) => {
  const handleSelectAll = (checked: boolean) => {
    transactions.forEach((t) => {
      onTransactionSelect(t.id, checked);
    });
  };

  return (
    <div className="mb-2">
      <Checkbox
        id={`select-all-${method}`}
        checked={
          transactions.length > 0 &&
          transactions.every((t) => selectedTransactions.has(t.id))
        }
        onCheckedChange={(checked) => handleSelectAll(checked === true)}
      />
      <Label htmlFor={`select-all-${method}`} className="ml-2">
        Tout sélectionner
      </Label>
    </div>
  );
};